// Vendor
import * as React from 'react';

// Internal
import { ChartShiftSpending } from '@src/charts/ChartShiftSpending';
import { Image } from '@src/components/Image';
import { SlideReveal } from '@src/components/SlideReveal';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

const ShoppersShift: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Shoppers Plan to Shift More Spend to Secondhand Than Any Other Channel
        in Next 5 Years
      </h1>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="tup-description max-w-xl"
      >
        where shoppers plan to spend more or less money in the next 5 years
        <sup>2</sup>
      </p>
      <div className="hidden md:block" style={{ height: 550 }}>
        <ChartShiftSpending />
      </div>
      <SlideReveal>
        <Image
          alt="Where Shoppers Plan to Shift spending in next 5 years Chart"
          addLink={true}
          className="block md:hidden"
          fileName="3a-chart-mobile.png"
        />
      </SlideReveal>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 2}
        className="tup-source md:ml-56 mt-2"
      >
        Responses represent buying intentions of consumers over the next 5 years
      </p>
    </div>
  );
};

export { ShoppersShift };
